function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import Select from "react-select";
import { generateOnKeyDownHandler } from "client/services/accessibility/accessibility-service";
import { withGenericConfig } from "contexts/generic-config-context";
import { LAYER_ONE } from "constants/z-index";
import { PERIOD_TEXTS } from "constants/pricing";
import { getPeriods } from "services/pricing/periods-service";
import { getMaxFreeUsersFromClusterConfig } from "services/pricing/discounts-service";
import { storeNumberOfSeats } from "services/sales-enrichment/sales-enrichment-service";
import { trackEvent } from "/services/bigbrain-service";
import { PRICING_PAGE_SEAT_DROPDOWN_OPENED } from "constants/bigbrain-event-types";
import { StyledUsersAndPeriodSelectionComponent } from "./users-and-periods-picker-component.scss";
class UsersAndPeriodsPickerComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsxs(StyledUsersAndPeriodSelectionComponent, {
            className: "users-and-period-picker-container",
            children: [
                this.renderUsersCountSelect(),
                this.renderPeriodsPicker()
            ]
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "onUpdateSelectedBillingPeriod", (event, periodName)=>{
            const { updateSelectedBillingPeriodCallBack } = this.props;
            updateSelectedBillingPeriodCallBack(periodName);
        });
        _define_property(this, "renderPeriodItem", (periodName, isSelected)=>{
            const { translate } = this.props;
            return /*#__PURE__*/ _jsx("div", {
                className: "period-item-container",
                tabIndex: 0,
                onClick: (event)=>this.onUpdateSelectedBillingPeriod(event, periodName),
                onKeyDown: generateOnKeyDownHandler(this.onUpdateSelectedBillingPeriod, periodName),
                role: "radio",
                "aria-checked": isSelected,
                children: /*#__PURE__*/ _jsx("div", {
                    className: classnames("period-item", {
                        selected: isSelected
                    }),
                    tabIndex: -1,
                    children: translate(PERIOD_TEXTS[periodName].displayName)
                }, periodName)
            }, periodName);
        });
        _define_property(this, "renderPeriodsPicker", ()=>{
            const { selectedPeriod, translate, cookies, abTests, forcePricing, ignoreClusterConfig } = this.props;
            const { clusterConfig } = ignoreClusterConfig ? {
                clusterConfig: {}
            } : this.props;
            const periods = getPeriods(clusterConfig, cookies, abTests, forcePricing);
            if (periods.length === 1) return null;
            return /*#__PURE__*/ _jsx("div", {
                className: "payments-pricing-periods-wrapper",
                role: "region",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "payments-pricing-periods",
                    role: "radiogroup",
                    "aria-label": translate("pricingPage.periods.title"),
                    children: periods.map((periodName)=>this.renderPeriodItem(periodName, periodName === selectedPeriod))
                })
            });
        });
        _define_property(this, "getUsersOptionLabel", (usersCount)=>{
            const { translateOrTranslateWithParam, cookies, abTests, forcePricing, ignoreClusterConfig } = this.props;
            const { clusterConfig } = ignoreClusterConfig ? {
                clusterConfig: {}
            } : this.props;
            const freeUsersCount = getMaxFreeUsersFromClusterConfig(clusterConfig, abTests, cookies, forcePricing);
            if (freeUsersCount > 0 && usersCount <= freeUsersCount) {
                return translateOrTranslateWithParam({
                    key: "pricingPage.seats.underXFree",
                    param: freeUsersCount
                });
            }
            return `${usersCount} ${translateOrTranslateWithParam("pricingPage.seats")}`;
        });
        _define_property(this, "getUsersSelectOptions", ()=>{
            const { usersCountArray } = this.props;
            return usersCountArray.map((usersCount)=>{
                return {
                    value: usersCount,
                    label: this.getUsersOptionLabel(usersCount)
                };
            });
        });
        _define_property(this, "updateSelectedUserCount", ({ value })=>{
            const { updateSelectedUserCountCallback } = this.props;
            storeNumberOfSeats(value);
            updateSelectedUserCountCallback(value);
        });
        _define_property(this, "onMenuOpen", ()=>{
            const { selectedUserCount } = this.props;
            trackEvent(PRICING_PAGE_SEAT_DROPDOWN_OPENED, {
                info2: selectedUserCount
            });
        });
        _define_property(this, "renderUsersCountSelect", ()=>{
            const { selectedUserCount, translate } = this.props;
            const selectedOption = {
                value: selectedUserCount,
                label: this.getUsersOptionLabel(selectedUserCount)
            };
            return /*#__PURE__*/ _jsxs("span", {
                className: "users-select-container",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "users-select-label",
                        id: "usersSelectLabel",
                        children: translate("pricingPage.chooseTeamSize")
                    }),
                    /*#__PURE__*/ _jsx(Select, {
                        name: "billing-users-selection",
                        className: "users-select-component",
                        isClearable: false,
                        isSearchable: false,
                        value: selectedOption,
                        onChange: this.updateSelectedUserCount,
                        onMenuOpen: this.onMenuOpen,
                        options: this.getUsersSelectOptions(),
                        "aria-labelledby": "usersSelectLabel",
                        styles: {
                            option: (base)=>{
                                return _object_spread_props(_object_spread({}, base), {
                                    zIndex: LAYER_ONE
                                });
                            }
                        }
                    })
                ]
            });
        });
    }
}
export default withGenericConfig(UsersAndPeriodsPickerComponent);
